export default __webpack_public_path__ + "static/media/back.cfd90d6c.svg";